/* =========================================================
   STUDIO SŌZŌ · CAPSULE FIN D'ANNÉE (animations communes)
   Un seul fichier pour toutes les sections "Capsule · …".
   Il ne fait rien sur les pages où ces sections sont absentes.
   ========================================================= */
(function(){
  if (window.MPV) return; /* déjà chargé par une autre section */

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;

  /* ---------- Gemmes facettées (SVG générés) ---------- */
  var GEMS = {
    star4:[[50,0],[62,38],[100,50],[62,62],[50,100],[38,62],[0,50],[38,38]],
    star6:[[50,0],[63.5,26.6],[93.3,25],[77,50],[93.3,75],[63.5,73.4],[50,100],[36.5,73.4],[6.7,75],[23,50],[6.7,25],[36.5,26.6]],
    heart:[[50,25],[62,10],[80,6],[95,18],[98,36],[88,56],[50,95],[12,56],[2,36],[5,18],[20,6],[38,10]],
    drop:[[50,0],[68,30],[80,55],[78,78],[65,94],[50,100],[35,94],[22,78],[20,55],[32,30]],
    baguette:[[28,0],[50,0],[72,0],[72,50],[72,100],[50,100],[28,100],[28,50]]
  };
  var COLORS = {
    violet:['#e9c8ff','#a45cff','#4b13a8'],
    blue:['#c4d0ff','#4f6bff','#1a238f'],
    lilac:['#f7e8ff','#c79bff','#7a49c9'],
    ruby:['#ffc9e0','#ff3f8e','#8c0b45'],
    pink:['#ffffff','#ffb3da','#d0629d']
  };
  var uid = 0;
  function gemSVG(shape, color){
    var p = GEMS[shape] || GEMS.star4, c = COLORS[color] || COLORS.violet, id = 'mpvg' + (uid++);
    var pts = p.map(function(q){ return q.join(','); }).join(' ');
    var inner = p.map(function(q){ return (50 + (q[0]-50)*.42).toFixed(1) + ',' + (50 + (q[1]-50)*.42).toFixed(1); }).join(' ');
    var facets = '';
    for (var i = 0; i < p.length; i++){
      var a = p[i], b = p[(i+1) % p.length], light = i % 2 === 0;
      var op = light ? (0.1 + ((i*7) % 5) * 0.07) : (0.08 + ((i*3) % 4) * 0.06);
      facets += '<polygon points="50,50 ' + a.join(',') + ' ' + b.join(',') + '" fill="' + (light ? '#fff' : '#1a0030') + '" fill-opacity="' + op.toFixed(2) + '"/>';
    }
    return '<svg viewBox="-4 -4 108 108" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<defs><linearGradient id="' + id + '" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="' + c[0] + '"/><stop offset=".5" stop-color="' + c[1] + '"/><stop offset="1" stop-color="' + c[2] + '"/></linearGradient></defs>' +
      '<polygon points="' + pts + '" fill="url(#' + id + ')" stroke="#fff" stroke-opacity=".7" stroke-width="1.2" stroke-linejoin="round"/>' +
      facets +
      '<polygon points="' + inner + '" fill="' + c[0] + '" fill-opacity=".35" stroke="#fff" stroke-opacity=".55" stroke-width=".8"/>' +
      '<path d="M34 22 Q35 30 43 31 Q35 32 34 40 Q33 32 25 31 Q33 30 34 22Z" fill="#fff" fill-opacity=".9"/>' +
      '</svg>';
  }

  /* ---------- Étincelles qui scintillent (canvas) ---------- */
  function sparkles(canvas){
    var ctx = canvas.getContext('2d'), stars = [], w, h, dpr, running = false, raf;
    function resize(){
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = canvas.offsetWidth; h = canvas.offsetHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.min(110, Math.round(w * h / 9000));
      stars = [];
      for (var i = 0; i < n; i++) stars.push({x: Math.random()*w, y: Math.random()*h, r: 3 + Math.random()*9, p: Math.random()*6.3, s: .6 + Math.random()*1.8});
    }
    function star(x, y, r){
      ctx.beginPath(); ctx.moveTo(x, y - r);
      ctx.quadraticCurveTo(x, y, x + r, y); ctx.quadraticCurveTo(x, y, x, y + r);
      ctx.quadraticCurveTo(x, y, x - r, y); ctx.quadraticCurveTo(x, y, x, y - r); ctx.fill();
    }
    function draw(t){
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = '#fff'; ctx.shadowColor = '#fff'; ctx.shadowBlur = 8;
      for (var i = 0; i < stars.length; i++){
        var s = stars[i], a = reduce ? .7 : Math.pow((Math.sin(t/1000*s.s + s.p) + 1) / 2, 3);
        ctx.globalAlpha = a; star(s.x, s.y, s.r * (.6 + a*.4));
      }
      ctx.globalAlpha = 1;
      if (running) raf = requestAnimationFrame(draw);
    }
    resize(); window.addEventListener('resize', resize);
    if (reduce || !('IntersectionObserver' in window)){ draw(0); return; }
    new IntersectionObserver(function(e){
      if (e[0].isIntersecting && !running){ running = true; raf = requestAnimationFrame(draw); }
      else if (!e[0].isIntersecting){ running = false; cancelAnimationFrame(raf); }
    }).observe(canvas);
  }

  /* ---------- Traînée de paillettes au curseur (ordinateur uniquement) ---------- */
  var trailOn = false;
  function startTrail(){
    if (trailOn || reduce || !fine) return; trailOn = true;
    var last = 0, cols = ['#ff4fa3','#a45cff','#4f6bff','#ffd166','#ffffff'];
    document.addEventListener('pointermove', function(e){
      if (!document.querySelector('[data-mpv-trail="true"]')) return;
      var now = performance.now(); if (now - last < 45) return; last = now;
      var s = document.createElement('span');
      s.className = 'mpv-trail'; s.textContent = Math.random() > .5 ? '✦' : '✧';
      s.style.left = e.clientX + 'px'; s.style.top = e.clientY + 'px';
      s.style.color = cols[Math.random() * cols.length | 0];
      s.style.fontSize = (10 + Math.random() * 12) + 'px';
      s.style.setProperty('--tx', (Math.random() * 40 - 20) + 'px');
      document.body.appendChild(s);
      setTimeout(function(){ s.remove(); }, 900);
    });
  }

  /* ---------- Apparition douce au scroll ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(x){ if (x.isIntersecting){ x.target.classList.add('is-in'); io.unobserve(x.target); } });
  }, {threshold: .12, rootMargin: '0px 0px -40px 0px'}) : null;

  function init(scope){
    (scope || document).querySelectorAll('.mpv').forEach(function(root){
      if (root.dataset.mpvReady) return; root.dataset.mpvReady = '1';
      root.classList.add('mpv-js');

      /* Gemmes */
      root.querySelectorAll('.mpv-gem').forEach(function(g){ g.innerHTML = gemSVG(g.dataset.gem, g.dataset.color); });

      /* Étincelles */
      root.querySelectorAll('.mpv-sparkles').forEach(sparkles);

      /* Parallaxe des gemmes du hero */
      root.querySelectorAll('.mpv-hero').forEach(function(hero){
        if (reduce || !fine) return;
        hero.addEventListener('pointermove', function(e){
          var r = hero.getBoundingClientRect();
          hero.style.setProperty('--mx', (((e.clientX - r.left) / r.width) - .5) * -30);
          hero.style.setProperty('--my', (((e.clientY - r.top) / r.height) - .5) * -30);
        });
      });

      /* Apparition au scroll */
      root.querySelectorAll('.mpv-reveal').forEach(function(el){ if (io) io.observe(el); else el.classList.add('is-in'); });

      /* Bandeaux défilants : textes séparés par | */
      root.querySelectorAll('.mpv-marquee').forEach(function(m){
        var src = m.querySelector('.mpv-marquee__items'), track = m.querySelector('.mpv-marquee__track');
        if (!src || !track) return;
        var items = (src.textContent || '').split('|'), html = '';
        for (var r = 0; r < 3; r++) items.forEach(function(t){
          t = t.trim(); if (!t) return;
          var span = document.createElement('span'); span.textContent = t;
          html += '<span class="mpv-marquee__item">' + span.innerHTML + '</span><span class="mpv-marquee__star">✦</span>';
        });
        track.innerHTML = '<div class="mpv-marquee__group">' + html + '</div><div class="mpv-marquee__group">' + html + '</div>';
      });

      /* Carrousels */
      root.querySelectorAll('.mpv-rail').forEach(function(rail){
        var track = rail.querySelector('.mpv-rail__track'),
            prev = rail.querySelector('[data-dir="-1"]'), next = rail.querySelector('[data-dir="1"]');
        if (!track) return;
        function step(){
          var c = track.querySelector('.mpv-card');
          return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : 300;
        }
        function update(){
          if (!prev || !next) return;
          prev.disabled = track.scrollLeft <= 4;
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        }
        [prev, next].forEach(function(b){
          if (b) b.addEventListener('click', function(){
            track.scrollBy({left: step() * Number(b.dataset.dir) * (window.innerWidth >= 990 ? 2 : 1), behavior: reduce ? 'auto' : 'smooth'});
          });
        });
        track.addEventListener('scroll', update, {passive: true});
        window.addEventListener('resize', update); update();
      });

      /* Comptes à rebours */
      root.querySelectorAll('.mpv-countdown').forEach(function(cd){
        var target = Date.parse(cd.dataset.target); if (isNaN(target)) return;
        var u = {}; ['d','h','m','s'].forEach(function(k){ u[k] = cd.querySelector('[data-u="' + k + '"]'); });
        var timer;
        function pad(n){ return (n < 10 ? '0' : '') + n; }
        function tick(){
          var s = Math.floor((target - Date.now()) / 1000);
          if (s <= 0){ cd.classList.add('is-ended'); clearInterval(timer); return; }
          if (u.d) u.d.textContent = pad(Math.floor(s / 86400));
          if (u.h) u.h.textContent = pad(Math.floor(s % 86400 / 3600));
          if (u.m) u.m.textContent = pad(Math.floor(s % 3600 / 60));
          if (u.s) u.s.textContent = pad(s % 60);
        }
        tick(); timer = setInterval(tick, 1000);
      });

      /* Portrait chinois : cartes à retourner */
      root.querySelectorAll('.mpv-clue').forEach(function(c){
        var btn = c.querySelector('.mpv-clue__btn'); if (!btn) return;
        var unlock = c.dataset.unlock ? Date.parse(c.dataset.unlock) : 0;
        function locked(){
          var l = !!unlock && Date.now() < unlock;
          c.classList.toggle('is-locked', l);
          btn.setAttribute('aria-disabled', l ? 'true' : 'false');
          return l;
        }
        locked();
        btn.addEventListener('click', function(){
          if (locked()) return;
          var f = c.classList.toggle('is-flipped');
          btn.setAttribute('aria-pressed', f ? 'true' : 'false');
        });
      });

      /* Traînée au curseur si une section l'active */
      if (document.querySelector('[data-mpv-trail="true"]')) startTrail();
    });
  }

  window.MPV = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); });
  else init(document);
  /* Éditeur de thème Shopify : relance quand une section est ajoutée ou modifiée */
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
